const parseTags = value => {
    if (value == null || value === '') {
        return [];
    }

    if (typeof value === 'string') {
        try {
            return parseTags(JSON.parse(value));
        } catch {
            return null;
        }
    }

    if (!Array.isArray(value)) {
        return null;
    }

    return value.filter(tag => tag && typeof tag === 'object');
};

const tagId = tag => (tag?.id == null || tag.id === '' ? null : String(tag.id));

const sameText = (left, right) => String(left ?? '') === String(right ?? '');

const toDisplay = value => (value == null || value === '' ? null : String(value));

const pushChange = (lines, key, label, oldValue, newValue) => {
    if (sameText(oldValue, newValue)) {
        return;
    }

    lines.push({
        key,
        label,
        old: toDisplay(oldValue),
        new: toDisplay(newValue),
    });
};

export const formatTagHistoryChanges = (field, diff, translate) => {
    if (field !== 'tags') {
        return null;
    }

    const oldTags = parseTags(diff?.old);
    const newTags = parseTags(diff?.new);

    if (!oldTags || !newTags) {
        return null;
    }

    const labelPl = translate('resources.product.fields.tags');
    const labelEn = translate('resources.tagCategory.fields.tagsEn');
    const lines = [];
    const oldById = new Map();

    oldTags.forEach(tag => {
        const id = tagId(tag);
        if (id) {
            oldById.set(id, tag);
        }
    });

    const usedOldIds = new Set();
    const unusedOldWithoutId = oldTags.filter(tag => !tagId(tag));

    newTags.forEach((tag, index) => {
        const id = tagId(tag);

        if (id && oldById.has(id)) {
            const oldTag = oldById.get(id);
            usedOldIds.add(id);
            pushChange(lines, `${id}-name`, labelPl, oldTag.name, tag.name);
            pushChange(lines, `${id}-nameEn`, labelEn, oldTag.nameEn, tag.nameEn);
            return;
        }

        if (!id) {
            const matchIndex = unusedOldWithoutId.findIndex(oldTag => sameText(oldTag.name, tag.name) && sameText(oldTag.nameEn, tag.nameEn));

            if (matchIndex !== -1) {
                unusedOldWithoutId.splice(matchIndex, 1);
                return;
            }
        }

        const keyBase = id ? `added-${id}` : `added-${index}`;
        pushChange(lines, `${keyBase}-name`, labelPl, null, tag.name);
        pushChange(lines, `${keyBase}-nameEn`, labelEn, null, tag.nameEn);
    });

    oldTags.forEach(tag => {
        const id = tagId(tag);
        if (!id || usedOldIds.has(id)) {
            return;
        }

        pushChange(lines, `removed-${id}-name`, labelPl, tag.name, null);
        pushChange(lines, `removed-${id}-nameEn`, labelEn, tag.nameEn, null);
    });

    unusedOldWithoutId.forEach((tag, index) => {
        pushChange(lines, `removed-${index}-name`, labelPl, tag.name, null);
        pushChange(lines, `removed-${index}-nameEn`, labelEn, tag.nameEn, null);
    });

    return lines;
};
